import React from "react";
import { createPortal } from "react-dom";

// In-app confirmation dialog. Native window.confirm is silently blocked in
// embedded iframes (e.g. the preview pane), so always use this instead.
export function ConfirmDialog({ open, message, confirmLabel = "Confirm", onConfirm, onCancel, testId = "confirm" }) {
  if (!open) return null;
  return createPortal(
    <div data-testid={`${testId}-dialog`} className="fixed inset-0 z-[80] flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(10,31,68,0.7)" }} onClick={onCancel}>
      <div className="bg-white rounded-2xl w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <p className="text-[#1A1A1A] text-base leading-relaxed mb-6">{message}</p>
        <div className="flex gap-3">
          <button data-testid={`${testId}-cancel`} onClick={onCancel}
            className="flex-1 rounded-lg px-4 py-2.5 font-medium border" style={{ borderColor: "#E5E7EB" }}>Cancel</button>
          <button data-testid={`${testId}-ok`} onClick={onConfirm}
            className="flex-1 rounded-lg px-4 py-2.5 font-semibold text-white" style={{ backgroundColor: "#F97316" }}>{confirmLabel}</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
